// fxlayer.ts — a full-viewport <canvas> the particle effect draws onto, sitting above the stage.
// Kept separate so the MediaRecorder / frame-strip capture has one canvas to sample.

let canvas: HTMLCanvasElement;
let ctx: CanvasRenderingContext2D;

export function initFxLayer(): HTMLCanvasElement {
  canvas = document.createElement("canvas");
  canvas.id = "fx-layer";
  Object.assign(canvas.style, {
    position: "fixed",
    inset: "0",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: "50",
  });
  ctx = canvas.getContext("2d")!;
  const resize = () => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  resize();
  window.addEventListener("resize", resize);
  document.body.appendChild(canvas);
  return canvas;
}

export function fxCtx(): CanvasRenderingContext2D {
  return ctx;
}
export function fxCanvas(): HTMLCanvasElement {
  return canvas;
}
